import {BitmapText} from "pixi.js";
import {DrawFrmThing} from "../drawfrm/DrawFrmThing";
import {FrmRefPoint} from "../drawfrm/FrmRefPoint";
import {lineBlueHeavy} from "../const";
import {formatAngle} from "../components/AngleEditor";

const FONT_SIZE = 10;
const LABEL_GAP = 4;

// the plan angle at a turn of the top-down run: the angle written just off the
// vertex, with an arc round it on the side the angle is measured on. Drawn in a frame
// whose +x axis is the run's direction coming into the turn; the arc spans from the
// outgoing direction (`turnRad` off +x, clockwise positive) round through +y back to
// the incoming run. `anchor` sits at the vertex, so the owner links it there.
// `radius` is the arc's minimum; it grows to clear the text.
export class AngleMarker extends DrawFrmThing {
    anchor: FrmRefPoint;
    private label: BitmapText;

    constructor(opt: {deg: number; turnRad: number; radius: number}) {
        super();

        this.anchor = new FrmRefPoint({name: "angleMarker", graphic: this.graphic, staticX: 0, staticY: 0});

        const mid = (opt.turnRad + Math.PI) / 2;
        const t = new BitmapText(formatAngle(opt.deg) + " deg", {fontName: "Arial", fontSize: FONT_SIZE});
        t.anchor.set(0.5, 0.5);
        t.tint = lineBlueHeavy;

        // the text sits on the bisector with its near edge a gap off the vertex; the arc
        // runs outside its far corner.
        const near = LABEL_GAP + Math.max(t.width, t.height) / 2;
        t.position.set(Math.cos(mid) * near, Math.sin(mid) * near);
        const far = near + Math.hypot(t.width, t.height) / 2 + LABEL_GAP;
        const radius = Math.max(opt.radius, far);

        const g = this.lines;
        g.lineStyle(1, lineBlueHeavy, 1);
        g.arc(0, 0, radius, opt.turnRad, Math.PI);

        this.graphic.addChild(t);
        this.label = t;
    }

    // keep the text level on screen whatever the marker's own rotation is.
    levelText() {
        this.label.rotation = -this.graphic.rotation;
    }
}
